import { useMemo } from 'react';
import { featureEnabled, features } from '../../../constants/features';
import { useEnv } from '../../../context/env-context';
import { useSite } from '../../../context/page-context';
import { PARTNER_GROUPS, PARTNERS } from '../constants';
import type { Partner, PartnerGroup } from '../types';

export function usePartnerCatalogue(): PartnerGroup[] {
  const site = useSite();
  const env = useEnv();

  return useMemo(() => {
    return PARTNER_GROUPS.filter(
      (group) =>
        group.type !== 'accountancy' ||
        featureEnabled(features.ACCOUNTING, site.siteId, env.platform),
    ).map((group) => ({
      type: group.type,
      partners: group.partnerIds
        .map((id) => PARTNERS.find((partner) => partner.id === id))
        .filter((partner): partner is Partner => {
          if (!partner) {
            return false;
          }
          return !partner.feature || featureEnabled(partner.feature, site.siteId, env.platform);
        }),
    }));
  }, [site.siteId, env.platform]);
}
